/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiDescriptionListTitle, EuiDescriptionListDescription, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { TrafficFilterRulesetInfo } from '@modules/cloud-api/v1/types'
import { getCspRegionIdFromRegionId } from '@modules/cloud-lib/providers'

interface Props {
  ruleset: TrafficFilterRulesetInfo
}

const RegionDetail: React.FC<Props> = ({ ruleset }) => (
  <React.Fragment>
    <EuiDescriptionListTitle>
      <FormattedMessage id='trafficFilterDetail.region' defaultMessage='Region' />
    </EuiDescriptionListTitle>
    <EuiDescriptionListDescription>
      <EuiText size='s'>{getCspRegionIdFromRegionId(ruleset.region)}</EuiText>
    </EuiDescriptionListDescription>
  </React.Fragment>
)

export default RegionDetail
